/*
**  rui-fixed-layout-container.js
**
**  rui-fixed-layout-container component
*/
import { LitElement, html, css } from 'lit';
import { ruiCommonStylesFixedLayout } from '../common/rui-common-styles-fixed-layout.js';
export class RuiFixedLayoutContainer extends LitElement {
    static get is() {
        return 'rui-fixed-layout-container';
    }
    static get properties() {
        return {
            orientation: { type: String },
            width: { type: String },
            height: { type: String }
        };
    }
    constructor() {
        super();
        this.orientation = '';
        this.width = '';
        this.height = '';
    }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('rui-fixed-layout-vertical-scrolling', (e) => this.fixedLayoutVerticalScrolling(e));
    }
    disconnectedCallback() {
        window.removeEventListener('rui-fixed-layout-vertical-scrolling', (e) => this.fixedLayoutVerticalScrolling(e));
        super.disconnectedCallback();
    }
    fixedLayoutVerticalScrolling(e) {
        if (e.detail) {
            this.setAttribute('data-rui-fixed-layout-vertical-scrolling', '');
        }
        else {
            this.removeAttribute('data-rui-fixed-layout-vertical-scrolling');
        }
    }
    render() {
        // All the real work here is done using :host + attributes in the component's CSS
        return html `<slot></slot>`;
    }
    static get styles() {
        return [
            ruiCommonStylesFixedLayout,
            css `
                :host([orientation="horizontal"]) {
                    display: flex;
                    flex-direction: row;
                    align-content: stretch;
                    gap: var(--rui-fixed-layout-gap-size, 12px);
                    height: calc(100% - 2px);
                    padding: 0;
                    min-height: 0;
                }

                :host([orientation="vertical"]) {
                    display: flex;
                    flex-direction: column;
                    align-content: stretch;
                    gap: var(--rui-fixed-layout-gap-size, 12px);
                    height: 100%;
                    padding: 0;
                    min-height: 0;
                }

                :host([data-rui-fixed-layout-vertical-scrolling]) {
                    display: block;
                    margin: 0;
                }

                @media print {
                    :host([orientation="horizontal"]),
                    :host([orientation="vertical"]) {
                        display: block;
                        margin: 0;
                    }
                }
            `
        ];
    }
}
customElements.get(RuiFixedLayoutContainer.is) || customElements.define(RuiFixedLayoutContainer.is, RuiFixedLayoutContainer);
